<template lang="slm">
section.Campaign.is-square style="width: 100%;"
  .container
    .columns
      .column.is-6-widescreen.is-offset-1-widescreen.is-7-tablet.is-offset-1-tablet
        .Campaign-image ref="imageContainer"
          image-source v-if="width" :source="imageUrl" :widths="widths" :ratio=1 :alt="text" :width="width"
        .Campaign-textBox
          router-link :to="link"
            .Campaign-content
              h2.Campaign-heading.title {{text}}
              .Campaign-readMore.trailingarrow {{ctaText}}
</template>

<script>
import ImageSource from '@/components/ImageSource'

export default {
  components: {
    'image-source': ImageSource
  },
  props: ['text', 'link', 'linkText', 'imageUrl', 'ctaText'],
  data () {
    return {
      'widths': [600, 800, 1100],
      'width': null
    }
  },
  mounted () {
    this.width = this.$refs.imageContainer.clientWidth
  }
}
</script>

<style lang="sass">
.is-square
  .Campaign-image
    z-index: -2
    position: relative

  .Campaign-textBox::after
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAHElEQVQYV2M0jk39f3bxbEYGKIAzMARgKjFUAABUnQgFfxFBTAAAAABJRU5ErkJggg==) repeat
    content: ""
    display: inline-block
    position: absolute
    width: 100%
    height: 100%
    top: 10%
    left: 3%
    z-index: -1

  .Campaign-image
    position: relative
    width: 100%
    display: block
    img
      width: 100%
</style>



// WEBPACK FOOTER //
// src/components/CampaignSquare.vue